import React, {useEffect} from 'react';
import {useDownloadURL} from "react-firebase-hooks/storage";
import {XMarkIcon} from "@heroicons/react/24/solid";
import {firebaseStorage, storageRef} from "../../firebase/client-app";

const EditImageSmall = ({imageDetail, selectedImage, removeFromSelectedList}) => {
    const [value, loading, error] = useDownloadURL(storageRef(firebaseStorage, imageDetail?.thumbnail));

    let modes = {
        'fill': 'cover',
        'fit': 'contain'
    };

    let size = modes['fit'] || 'contain';

    let defaults = {
        height: 100,
        width: 100,
        backgroundColor: 'bg-white',
    };

    return (
        <>
            {!loading && value &&
                <div className="border-gray-200 bg-white hover:bg-neutral-400 border rounded m-1 cursor-pointer p-2">
                    <div style={{
                        ...defaults, backgroundSize: size,
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                        backgroundImage: `url("${value}")`
                    }}/>
                    <div className="mt-2">
                        <button onClick={() => {
                            removeFromSelectedList(imageDetail)
                        }} className="button-gray-outline h-8 w-full m-auto">
                            Remove
                        </button>
                    </div>
                </div>

            }

            {loading && !value &&
                <div
                    className="border-gray-200 bg-white hover:bg-neutral-400 border rounded m-1 cursor-pointer p-2">
                    <div style={{
                        ...defaults, backgroundSize: size,
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                    }}/>
                    <div className="h-10">

                    </div>
                </div>
            }
        </>
    )
}

export default EditImageSmall
